import * as React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import styled from "styled-components";
import ToggleDisplay from "../../../../utils/ToggleDisplay";

const WarningBox = styled.div`
  border: 0.2rem solid red;
  padding: 1rem 5rem;
`;

interface IMalformedQuestionWarningProps {
  messages: string[];
}

const MalformedQuestionWarning: React.SFC<IMalformedQuestionWarningProps> = props => (
  <ToggleDisplay shouldDisplay={props.messages.length > 0}>
    <WarningBox>
      <p>
        <FaExclamationTriangle /> This part will not be shown in the learning app since it is not well-formed:
      </p>
      <ol>
        {props.messages.map((message, i) => (
          <li key={i}>{message}</li>
        ))}
      </ol>
    </WarningBox>
  </ToggleDisplay>
);

export default MalformedQuestionWarning;
